import * as React from "react";
import {useEffect, useContext, useState} from "react";
import {Home} from "../queries/Home";
import {HomeContext} from "../state/homeContext";

export const useHome = () => {
    const {state, dispatch} = useContext(HomeContext);
    const [testimonials, setTestimonials] = useState([]);
    const [isScheduleLoading, setScheduleLoading] = useState(false);

    useEffect(()=> {
        setScheduleLoading(true);
        state.length === 0 &&
        Home.getSchedule().then((response) => {
            dispatch({type: "initHomeComponentList",payload:response});
            setScheduleLoading(false);
        }).catch(() => {
            setScheduleLoading(false);
        });
        Home.getTestimonials().then((response) => setTestimonials(response));
    },[])

    return {schedule:state, testimonials, isScheduleLoading}
}
